import { KEYS } from '../../../../../../../l18n/constants';
import {useL18nContext} from '../../../../../ContextProvider/L18n';
import {usePartnerSearchContext} from '../../../../../ContextProvider/Partner/Search';
import computeClassName from '../../../../../../../utils/computeClassName';
import CCIconChevronRight12x12 from '../../../../../../libs/CiscoCore/Icon/Chevron/Right/12x12';
import handleClick from '../../../../../../../utils/handleClick';

const constants = Object.freeze({
  CLASSNAME_BASE: "flex flex-row items-center text-cc-white decoration-none text-cc-body-small-thick font-medium 3xs:font-medium 3xs:text-cc-body-medium sm:font-normal sm:text-cc-body-large",
});

function computeHandleClickFn(searchByLocationSelectionFn) {
  return (e) => {
    e.preventDefault();
    handleClick(searchByLocationSelectionFn)();
  }
}

export default function ChangeSearchLocationControl({className}) {
  const { isSearchByLocationFormSelected, selectSearchByLocationForm } = usePartnerSearchContext();
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const computedHandleClickFn = computeHandleClickFn(selectSearchByLocationForm);
  const { getTranslationFor } = useL18nContext();
  const changeLocationTranslatedLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_CHANGE_LOCATION);
// <span className={computedClassName}>&nbsp;</span>
  return isSearchByLocationFormSelected() ?
    <></> :
    (
      <a href="/"
         className={computedClassName}
         onClick={computedHandleClickFn}>{changeLocationTranslatedLabel}<CCIconChevronRight12x12 className="ml-1 3xs:ml-1.5 xs:ml-2 h-2 xs:h-2.5"/></a>
    );
}
